import React from "react";

export default function SocialIcons({ socials, className = "" }) {
  if (!socials?.length) return null;

  return (
    <div className={`flex items-center gap-4 ${className}`}>
      {socials.map((social) => (
        <a
          key={social.name}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-2 rounded-full bg-white/5 px-3 py-2 hover:bg-white/10 transition"
        >
          <img
            src={social.icon}
            alt={social.name}
            className="h-6 w-6 object-contain drop-shadow group-hover:scale-105 transition"
          />
          <span className="text-sm text-white font-semibold">{social.name}</span>
        </a>
      ))}
    </div>
  );
}
